import React, { useContext } from "react";
import Button from "../../Base/Button/Button.jsx";
import Modal from "../../Base/Modal/Modal.jsx";
import { FixtureDetailsContext } from "../../../Config/FixtureDetails.jsx";
import { sendClockEvent } from "../../Base/Utilities/ClockEvents.js";

function EndMatchModal(props) {
  const { currentState, intl, updateState, setShowModal } = props;
  const { formatMessage } = intl;
  const { period } = currentState;
  const { sport } = useContext(FixtureDetailsContext);

  return (
    <Modal
      className="end-match-modal"
      title={formatMessage({
        id: "match.end",
        defaultMessage: "End Match",
      })}
      onClose={() => {
        setShowModal(null);
      }}
    >
      <p className="end-match-modal__text">
        {formatMessage({
          id: "match.end.confirmationMessage.first",
          defaultMessage:
            "To finalize the match, click END MATCH. If no further review is required, click END & CONFIRM.",
        })}
        <br />
        {formatMessage({
          id: "match.end.confirmationMessage.second",
          defaultMessage: "Please note that by selecting END & CONFIRM, no additional changes can be made.",
        })}
      </p>
      <p className="end-match-modal__text">
        {formatMessage({
          id: "match.end.confirmationMessage.cancel",
          defaultMessage: "To continue editing without ending match, click CANCEL.",
        })}
      </p>

      <div className="end-match-modal__button-row">
        <Button
          variant="success"
          onClick={() => {
            sendClockEvent("sport", "fixture", "end", props);

            if (sport === "handball") {
              sendClockEvent("internal", "betStop", null, props);
            }

            updateState("period", {
              periodId: period.periodId,
              periodStatus: "fixtureConfirm",
            });

            setShowModal(null);
          }}
        >
          {formatMessage({ id: "endMatch", defaultMessage: "End Match" })}
        </Button>

        <Button
          variant="success"
          onClick={() => {
            sendClockEvent("sport", "fixture", "end", props);
            sendClockEvent("sport", "fixture", "confirmed", props);

            if (sport === "handball") {
              sendClockEvent("internal", "betStop", null, props);
            }

            updateState("period", {
              periodId: period.periodId,
              periodStatus: "fixtureComplete",
            });

            setShowModal(null);
          }}
        >
          {formatMessage({ id: "endAndConfirm", defaultMessage: "End & Confirm" })}
        </Button>
      </div>

      <div className="end-match-modal__button-row">
        <Button
          onClick={() => {
            setShowModal(null);
          }}
          variant="cancel"
        >
          {formatMessage({ id: "cancel", defaultMessage: "Cancel" })}
        </Button>
      </div>
    </Modal>
  );
}

export default EndMatchModal;
